import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatTreeModule} from '@angular/material/tree';
import {LeftPanelComponent} from '@shared/components/left-panel/left-panel.component';
import {LeftPanelContainer} from '@shared/components/left-panel/left-panel.container';
import {VendorModule} from '@shared/components/vendor/vendor.module';
import {AmcIconifyModule, PerfectScrollDirectiveModule} from 'amc-common-components';

@NgModule({
	imports: [CommonModule, MatTreeModule, AmcIconifyModule, PerfectScrollDirectiveModule, VendorModule],
	declarations: [LeftPanelContainer, LeftPanelComponent],
	exports: [LeftPanelContainer],
})
export class LeftPanelModule {}
